import { abyssColors } from '@/theme/colors';
import { styled as muiStyled, Stack } from '@mui/material';
import { File } from '@/__generated__/graphql';

export const MainImageContainer = muiStyled(Stack)(() => ({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  borderRadius: '0.2rem',
  padding: '0.4rem',
  border: `0.1rem solid ${abyssColors.primary[100]}`,
  transition: 'all 0.2s ease-in-out',
}));

export const ScrollContainer = muiStyled(Stack)({
  flex: 1,
  display: 'block',
  height: 'auto',
  minHeight: 'fit-content',
  overflowX: 'auto',
  overflowY: 'hidden',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  cursor: 'grabbing',
  width: '100%',
  alignItems: 'center',
});

export const getThumbnailStyles = (selectedIsometricFileId: string, file: File) => {
  return {
    height: '8rem',
    width: 'fit-content',
    borderRadius: '0.4rem',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    boxSizing: 'border-box',
    border:
      selectedIsometricFileId === file?.id
        ? `0.2rem solid ${abyssColors.secondary[600]}`
        : `0.2rem solid transparent`,
    '&:hover': {
      border: `0.2rem solid ${abyssColors.secondary[300]}`,
    },
  };
};
